import {controller} from '@github/catalyst'
import {BaseFilterElement} from '../filter-input'

@controller('repository-advisories-filter')
class RepositoryAdvisoriesFilterElement extends BaseFilterElement {
  override showAllQualifiersIfNoneMatch = false
  override fuzzyMatchQualifiers = true
  override showSubmissionOptionIfInvalidSearchTerms = true
  override suggestionsTitle = 'Narrow your search'
  // Suggestions are qualifier:value pairs, so do not render a space.
  override spaceBetweenValueAndDescription = false
}
